import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: 'ion-textarea[autosize]' // Attribute selector,
})
export class AutosizeDirective {
  constructor(public element:ElementRef) {
    console.log('Autosize directive loaded');
  }

  ngAfterViewInit(){
    var me = this;
    this.element.nativeElement.addEventListener('keyup', function() {
      me.adjust();
    })
    this.element.nativeElement.addEventListener('change', function() {
      setTimeout(function() {
        me.adjust();
      }, 50);
    })
  }

  adjust():void {
    let textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
    textArea.style.overflow = 'hidden';
    textArea.style.height = 'auto';
    textArea.style.height = (textArea.scrollHeight) + "px";
    console.log('adjust', textArea.scrollHeight);
  }

}



// WEBPACK FOOTER //
// ./src/directives/autosize/autosize.ts